import getCheckMobileReg from "./checkMobileReg";
let checkMobileReg = '';
if (!checkMobileReg) {
  getCheckMobileReg().then((reg) => {
    checkMobileReg = reg;
  });
}

export default function (isRequired = true) {
  return function (rule, value, callback) {
    if (isRequired && !value) {
      return callback(new Error("请输入手机号"));
    }

    if (value && checkMobileReg && !checkMobileReg.test(value)) {
      return callback(new Error("请输入正确的手机号"));
    }

    return callback();
  }
}